// src/components/Accordion.js
import React, { useState, useRef, useEffect } from 'react';
import './Accordion.css';

function Accordion({ children, collapsedHeight = '30vh' }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [maxHeight, setMaxHeight] = useState(collapsedHeight);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      if (isExpanded) {
        setMaxHeight(`${contentRef.current.scrollHeight}px`);
      } else {
        setMaxHeight(collapsedHeight);
      }
    }
  }, [isExpanded, collapsedHeight, children]);

  const toggleAccordion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="accordion">
      {/* Expand/Collapse Buttons */}
      {isExpanded && (
        <>
          <div className="bottom-button">
            <button className="button button-m" onClick={toggleAccordion}>
              收合
            </button>
          </div>
        </>
      )}
      <div
        className="accordion-content"
        style={{ maxHeight }}
        ref={contentRef}
      >
        {children}
        {!isExpanded && (
          <div className="fadeout">
            <button
              className="button button-m accordion-toggle bottom"
              onClick={toggleAccordion}
            >
              展開
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Accordion;
